import { Get } from '../helpers';

export function GetProjectPublishedStatus(
  projectUuid: string
): Promise<{ status: number; url: string; timestamp?: string }> {
  return Get({
    path: `/v3/admin/events/published-status/${projectUuid}`,
  });
}
